import React from "react";
import style from "./Header.module.scss";
import logo from "../../../../components/Header/img/logo.png";
import logo2 from "./img/bg.png";

export default function Header() {
    return (
        <div className={style.root}>
            <div className={style.logo}>
                <a href="http://data.edufe.com.cn/?f=aliaction&m=dufemap">
                    <img src={logo} alt="Dufe" />
                    <span className={style.logoText}>白果云课堂</span>
                </a>
            </div>

            <div className={style.logo2}>
                <img src={logo2} alt="" />
            </div>
        </div>
    );
}
